import {Component, Input, OnInit} from '@angular/core';
import {UtilService} from '../services/UtilService';

@Component({
  selector: 'app-index-performance-analytics-page',
  templateUrl: './index-performance-analytics-page.component.html',
  styleUrls: ['./index-performance-analytics-page.component.scss']
})
export class IndexPerformanceAnalyticsPageComponent implements OnInit {

  @Input() indexData: any;
  @Input() indexType: any;
  constructor(public utilService: UtilService) { }

  ngOnInit(): void {
  }

}
